<section class="min-h-screen" [formGroup]="createForm">
  <div class="max-w-6xl mx-auto">

    <!-- Sticky Header -->
    <div class="bg-white sticky top-0 shadow-sm border-b border-gray-200 p-6 rounded-lg mb-6 z-20">
      <div class="flex justify-between items-center">
        <h1 class="text-xl font-bold text-gray-900">Create New Associate</h1>
        <div class="flex gap-3">
          <button (click)="onCancel()" class="btn btn-outline btn-sm px-6">Cancel</button>
          <button (click)="onSave()" class="btn btn-primary btn-sm px-6" [disabled]="isSaving">
            @if (isSaving) {
              <span class="inline-flex items-center gap-2">
                <span class="loading loading-spinner loading-sm"></span>
                Saving...
              </span>
            } @else {
              Save
            }
          </button>
        </div>
      </div>

      <!-- Associate Name -->
      <div class="mt-4">
        <label class="label">
          <span class="label-text font-semibold">Name <span class="text-red-500">*</span></span>
        </label>
        <input formControlName="client_company_name" type="text" placeholder="Enter associate name"
          class="input input-bordered w-full" [class.input-error]="isInvalid('client_company_name')" />
        <ng-container
          *ngTemplateOutlet="errMsg; context: { ctrl: f('client_company_name'), label: 'Name' }"></ng-container>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs tabs-boxed bg-white shadow-sm rounded-lg mb-6 gap-2 sticky top-[180px] z-10">
      <button class="tab tab-lg" [class.tab-active]="activeTab === 0" (click)="setTab(0)">Details</button>
      <button class="tab tab-lg" [class.tab-active]="activeTab === 1" (click)="setTab(1)">Admin Details</button>
      <button class="tab tab-lg" [class.tab-active]="activeTab === 2" (click)="setTab(2)">Courses</button>
      <button class="tab tab-lg" [class.tab-active]="activeTab === 3" (click)="setTab(3)">White Labelled</button>
      <button class="tab tab-lg" [class.tab-active]="activeTab === 4" (click)="setTab(4)">Analytics</button>
    </div>

    <!-- Tab Content -->
    <div class="bg-white rounded-lg shadow-sm p-8">

      <!-- ═══ TAB 0: Details ═══ -->
      @if (activeTab === 0) {
      <div>

        <h3 class="text-xl font-semibold mb-6 bg-blue-100 p-3 rounded-lg">About Us</h3>
        <div class="grid md:grid-cols-2 gap-6 mb-6">

          <div>
            <label class="label">
              <span class="label-text font-semibold">About College <span class="text-red-500">*</span></span>
            </label>
            <textarea formControlName="aboutCollege" rows="1" class="textarea textarea-bordered w-full"
              [class.textarea-error]="isInvalid('aboutCollege')"></textarea>
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('aboutCollege'), label: 'About College' }"></ng-container>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Category <span class="text-red-500">*</span></span>
            </label>
            <select formControlName="category" class="select select-bordered w-full"
              [class.select-error]="isInvalid('category')">
              <option value="">Select...</option>
              @for (cat of categories; track cat) {
              <option [value]="cat">{{ cat }}</option>
              }
            </select>
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('category'), label: 'Category' }"></ng-container>
          </div>

        </div>

        <h3 class="text-xl font-semibold mb-6 bg-blue-100 mt-6 p-3 rounded-lg">Address Details</h3>
        <div class="space-y-6 mb-8">

          <div>
            <label class="label">
              <span class="label-text font-semibold">Address <span class="text-red-500">*</span></span>
            </label>
            <textarea formControlName="address" rows="2" class="textarea textarea-bordered w-full"
              [class.textarea-error]="isInvalid('address')"></textarea>
            <ng-container *ngTemplateOutlet="errMsg; context: { ctrl: f('address'), label: 'Address' }"></ng-container>
          </div>

          <div class="grid md:grid-cols-2 gap-6">

            <div>
              <label class="label">
                <span class="label-text font-semibold">
                  City <span class="text-red-500">*</span>
                </span>
              </label>

              <input type="text" formControlName="city" placeholder="Enter city" maxlength="50"
                class="input input-bordered w-full" [class.input-error]="isInvalid('city')" />

              <ng-container *ngTemplateOutlet="
      errMsg;
      context: { ctrl: f('city'), label: 'City' }
    ">
              </ng-container>
            </div>

            <div>
              <label class="label">
                <span class="label-text font-semibold">
                  State <span class="text-red-500">*</span>
                </span>
              </label>

              <input type="text" formControlName="state" placeholder="Enter state" maxlength="50"
                class="input input-bordered w-full" [class.input-error]="isInvalid('state')" />

              <ng-container *ngTemplateOutlet="errMsg; context: { ctrl: f('state'), label: 'State' }">
              </ng-container>
            </div>
            <div>
              <label class="label">
                <span class="label-text font-semibold">
                  Country <span class="text-red-500">*</span>
                </span>
              </label>

              <input type="text" formControlName="country" placeholder="Enter country" maxlength="50"
                class="input input-bordered w-full" [class.input-error]="isInvalid('country')" />

              <ng-container *ngTemplateOutlet="errMsg; context: { ctrl: f('country'), label: 'Country' }">
              </ng-container>
            </div>

            <div>
              <label class="label">
                <span class="label-text font-semibold">Pin Code <span class="text-red-500">*</span></span>
              </label>
              <input formControlName="pin_code" type="text" maxlength="6" class="input input-bordered w-full"
                [class.input-error]="isInvalid('pin_code')" />
              <ng-container
                *ngTemplateOutlet="errMsg; context: { ctrl: f('pin_code'), label: 'Pin Code' }"></ng-container>
            </div>

          </div>
        </div>

        <h3 class="text-xl font-semibold mb-6 bg-blue-100 p-3 rounded-lg">Contact Details</h3>
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Contacts -->
          <div>
            <div class="flex justify-between items-center">
              <label class="label">
                <span class="label-text font-semibold">Contact No. <span class="text-red-500">*</span></span>
              </label>
              <button type="button" (click)="addContact()" class="text-blue-500 text-sm font-medium">+ Add</button>
            </div>
            <div formArrayName="contacts" class="space-y-2">
              @for (contact of contacts.controls; track contact; let i = $index) {
              <div [formGroupName]="i">
                <div class="flex gap-2">
                  <input formControlName="number" type="text" maxlength="15" class="input input-bordered w-full"
                    [class.input-error]="isArrayInvalid('contacts', i, 'number')" />
                  @if (contacts.length > 1) {
                  <button type="button" (click)="removeContact(i)" class="btn btn-sm btn-error">✕</button>
                  }
                </div>
                @if (isArrayInvalid('contacts', i, 'number')) {
                <div class="text-red-500 text-xs mt-1">
                  @if (getArrayCtrl('contacts', i, 'number')?.errors?.['required']) { Contact number is required. }
                  @else if (getArrayCtrl('contacts', i, 'number')?.errors?.['contactDigitsOnly']) { Only digits are allowed. }
                  @else if (getArrayCtrl('contacts', i, 'number')?.errors?.['contactLength']) { Contact number must be exactly 10 digits. }
                 
                </div>
                }
              </div>
              }
            </div>
          </div>

          <!-- Emails -->
          <div>
            <div class="flex justify-between items-center">
              <label class="label">
                <span class="label-text font-semibold">Email Id <span class="text-red-500">*</span></span>
              </label>
              <button type="button" (click)="addEmail()" class="text-blue-500 text-sm font-medium">+ Add</button>
            </div>
            <div formArrayName="emails" class="space-y-2">
              @for (email of emails.controls; track email; let i = $index) {
              <div [formGroupName]="i">
                <div class="flex gap-2">
                  <input formControlName="email" type="email" maxlength="100" class="input input-bordered w-full"
                    [class.input-error]="isArrayInvalid('emails', i, 'email')" />
                  @if (emails.length > 1) {
                  <button type="button" (click)="removeEmail(i)" class="btn btn-sm btn-error">✕</button>
                  }
                </div>
                @if (isArrayInvalid('emails', i, 'email')) {
                <div class="text-red-500 text-xs mt-1">
                  @if (getArrayCtrl('emails', i, 'email')?.errors?.['required']) { Email is required. }
                  @else if (getArrayCtrl('emails', i, 'email')?.errors?.['emailFormat']) { Please enter a valid email address. }
                  @else if (getArrayCtrl('emails', i, 'email')?.errors?.['emailMaxLength']) { Email must not exceed 100 characters. }
                  @else if (getArrayCtrl('emails', i, 'email')?.errors?.['emailNoSpaces']) { Email cannot contain spaces. }
                </div>
                }
              </div>
              }
            </div>
          </div>

        </div>

        <div class="flex justify-end mt-6">
          <button (click)="saveDetailsTab()" class="btn btn-primary btn-sm px-6">Next</button>
        </div>
      </div>
      }

      @if (activeTab === 1) {
      <div class="space-y-6">
        <div class="grid md:grid-cols-2 gap-6">

          <div>
            <label class="label">
              <span class="label-text font-semibold">Admin Name <span class="text-red-500">*</span></span>
            </label>
            <input formControlName="adminName" type="text" class="input input-bordered w-full"
              [class.input-error]="isInvalid('adminName')" />
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('adminName'), label: 'Admin Name' }"></ng-container>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Designation</span>
            </label>
            <input formControlName="designation" type="text" class="input input-bordered w-full" />
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('designation'), label: 'Designation' }"></ng-container>
          </div>
          <div>
            <div class="flex justify-between items-center">
              <label class="label">
                <span class="label-text font-semibold">Contact No. <span class="text-red-500">*</span></span>
              </label>
              <button type="button" (click)="addContact()" class="text-blue-500 text-sm font-medium">+ Add</button>
            </div>
            <div formArrayName="adminContacts" class="space-y-2">
              @for (email of adminEmails.controls; track $index; let i = $index) {
              <div [formGroupName]="i">
                <div class="flex gap-2">
                  <input formControlName="number" type="text" maxlength="15" class="input input-bordered w-full"
                    [class.input-error]="isArrayInvalid('adminContacts', i, 'number')" />
                  @if (adminContacts.length > 1) {
                  <button type="button" (click)="removeAdminContact(i)" class="btn btn-sm btn-error">✕</button>
                  }
                </div>
                @if (isArrayInvalid('adminContacts', i, 'number')) {
                <div class="text-red-500 text-xs mt-1">
                  @if (getArrayCtrl('adminContacts', i, 'number')?.errors?.['required']) { Contact number is required. }
                  @else if (getArrayCtrl('adminContacts', i, 'number')?.errors?.['contactDigitsOnly']) { Only digits are allowed. }
                  @else if (getArrayCtrl('adminContacts', i, 'number')?.errors?.['contactLength']) { Contact number must be exactly 10 digits. }
                </div>
                }
              </div>
              }
            </div>
          </div>

          <!-- Emails (Admin tab) -->
          <div>
            <div class="flex justify-between items-center">
              <label class="label">
                <span class="label-text font-semibold">Email Id <span class="text-red-500">*</span></span>
              </label>
              <button type="button" (click)="addAdminEmail()" class="text-blue-500 text-sm font-medium">+ Add</button>
            </div>
            <div formArrayName="adminEmails" class="space-y-2">
              @for (email of adminEmails.controls; track $index; let i = $index) {
              <div [formGroupName]="i">
                <div class="flex gap-2">
                  <input formControlName="email" type="email" maxlength="100" class="input input-bordered w-full"
                    [class.input-error]="isArrayInvalid('adminEmails', i, 'email')" />
                  @if (adminEmails.length > 1) {
                  <button type="button" (click)="removeAdminEmail(i)" class="btn btn-sm btn-error">✕</button>
                  }
                </div>
                @if (isArrayInvalid('adminEmails', i, 'email')) {
                <div class="text-red-500 text-xs mt-1">
                  @if (getArrayCtrl('adminEmails', i, 'email')?.errors?.['required']) { Email is required. }
                  @else if (getArrayCtrl('adminEmails', i, 'email')?.errors?.['emailFormat']) { Please enter a valid email address. }
                  @else if (getArrayCtrl('adminEmails', i, 'email')?.errors?.['emailMaxLength']) { Email must not exceed 100 characters. }
                  @else if (getArrayCtrl('adminEmails', i, 'email')?.errors?.['emailNoSpaces']) { Email cannot contain spaces. }
                </div>
                }
              </div>
              }
            </div>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Username <span class="text-red-500">*</span></span>
            </label>
            <input formControlName="username" type="text" class="input input-bordered w-full"
              [class.input-error]="isInvalid('username')" />
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('username'), label: 'Username' }"></ng-container>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Password <span class="text-red-500">*</span></span>
            </label>

            <div class="relative">
              <input formControlName="password" [type]="showPassword ? 'text' : 'password'"
                class="input input-bordered w-full pr-12" [class.input-error]="isInvalid('password')"
                (focus)="onPasswordFocus()" />
              <button type="button" (click)="togglePasswordVisibility()"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-900"
                aria-label="Toggle password visibility">
                <i class="ri-eye-line" *ngIf="!showPassword"></i>
                <i class="ri-eye-off-line" *ngIf="showPassword"></i>
              </button>
            </div>

            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('password'), label: 'Password' }"></ng-container>
          </div>


        </div>

        <div class="flex justify-end mt-6">
          <button (click)="saveAdminTab()" class="btn btn-primary btn-sm px-6">Next</button>
        </div>
      </div>
      }

      <!-- ═══ TAB 2: Courses ═══ -->
      @if (activeTab === 2) {
      <div>
        <h3 class="text-xl font-semibold bg-blue-100 p-3 rounded-lg mb-6">Assigned Courses</h3>
        <div class="flex justify-end mb-6">
          <button type="button" (click)="addCourse()" class="btn btn-primary">
            <i class="ri-add-line mr-2"></i>Add New Course
          </button>
        </div>

        @if (selectedCourses.length > 0) {
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          @for (course of selectedCourses; track course.id) {
          <div class="card bg-white shadow-md hover:shadow-xl transition-shadow rounded-lg overflow-hidden">
            <figure class="relative">
              <img [src]="getCourseThumbnailUrl(course.thumbnail)" [alt]="course.name"
                class="w-full h-full object-cover" />
              <!-- <button type="button" (click)="removeCourse(course.id)"
                class="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-red-500 text-white shadow-md transition hover:bg-red-600">
                Remove
              </button> -->
              <button type="button" (click)="removeCourse(course.id)"
                class="absolute right-3 top-3 flex items-center justify-center px-4 py-2 rounded-md bg-red-500 text-white shadow-md transition hover:bg-red-600">
                Remove Access
              </button>
            </figure>
            <div class="p-4">
              <h3 class="font-semibold mb-2">{{ course.name }}</h3>
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="text-center py-16 border-2 border-dashed border-gray-300 rounded-lg">
          <i class="ri-bookmark-line text-6xl text-gray-400 mb-4 block"></i>
          <p class="text-xl text-gray-500 mb-4">No courses assigned</p>
          <button type="button" (click)="addCourse()" class="btn btn-primary">Assign First Course</button>
        </div>
        }


        <div class="flex justify-end mt-6">
          <button (click)="saveCoursesTab()" class="btn btn-primary btn-sm px-6">Next</button>
        </div>
      </div>
      }

      <!-- ═══ TAB 3: White Labelled ═══ -->
      @if (activeTab === 3) {
      <div class="space-y-8">

        <div>
          <label class="label">
            <span class="font-semibold text-black">Opted for white labelled product? <span
                class="text-red-500">*</span></span>
          </label>
          <div class="flex gap-8">
            <label class="label cursor-pointer gap-2">
              <span class="text-black">Yes</span>
              <input type="radio" formControlName="whiteLabelled" [value]="1" class="radio radio-primary" />
            </label>
            <label class="label cursor-pointer gap-2">
              <span class="text-black">No</span>
              <input type="radio" formControlName="whiteLabelled" [value]="0" class="radio radio-primary" />
            </label>
          </div>
          @if (submitAttempted && f('whiteLabelled')?.errors?.['required']) {
          <p class="text-red-500 text-xs mt-1">Please select an option.</p>
          }
        </div>

        @if (createForm.get('whiteLabelled')?.value === 1) {
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">

          <div>
            <label class="label">
              <span class="label-text font-semibold">Institute Name <span class="text-red-500">*</span></span>
            </label>
<input formControlName="instituteName" type="text" class="input input-bordered w-full" 
              [class.input-error]="isInvalid('instituteName')" />
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('instituteName'), label: 'Institute Name' }"></ng-container>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Colour Code <span class="text-red-500">*</span></span>
            </label>
            <div class="flex items-center gap-4">
              <input formControlName="colourCode" type="color"
                class="h-12 w-20 rounded border-2 border-gray-300 bg-white" />
              <div class="flex items-center gap-3 flex-1">
                <div class="h-12 w-12 rounded-lg border flex-shrink-0" [style.background]="liveColourCode"
                  title="Live preview"></div>

              </div>
            </div>
            <ng-container
              *ngTemplateOutlet="errMsg; context: { ctrl: f('colourCode'), label: 'Colour Code' }"></ng-container>
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">Logo </span>
            </label>
            <div
              class="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center transition-colors hover:border-blue-500 cursor-pointer"
              (click)="logoInput.click()" [class.border-red-400]="submitAttempted && !logoPreview">
              @if (logoPreview) {
              <img [src]="logoPreview" alt="Logo" class="w-24 h-24 object-cover mx-auto rounded-lg mb-4 shadow-md" />
              <p class="text-sm text-gray-600">Click to replace</p>
              } @else {
              <i class="ri-image-add-line text-5xl text-gray-400 mb-4 block"></i>
              <p class="text-lg font-medium text-gray-700 mb-1">Upload Logo</p>
<p class="text-sm text-gray-500">Only JPG, JPEG, PNG up to 2MB</p>
              }
              <input type="file" (change)="onLogoUpload($event)" accept="image/png,image/jpeg,image/jpg" class="hidden" #logoInput />
            </div>
            @if (submitAttempted && !logoPreview) {
            <p class="text-red-500 text-xs mt-1">Logo is required.</p>
            }
          </div>

        </div>
        }

        <div class="flex justify-end mt-6">
          <button (click)="saveWhiteLabelTab()" class="btn btn-primary btn-sm px-6">Next</button>
        </div>
      </div>
      }

      <!-- ═══ TAB 4: Analytics ═══ -->
      @if (activeTab === 4) {
      <div class="space-y-6">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
          @for (stat of analyticsStats; track stat.label) {
          <div class="stat-card">
            <div class="flex items-start justify-between gap-4">
              <div>
                <p class="text-sm font-medium text-slate-500">{{ stat.label }}</p>
                <p class="mt-3 text-3xl font-semibold text-slate-900">{{ stat.value }}</p>
              </div>
              <span class="rounded-full px-3 py-1 text-xs font-semibold" [class.bg-orange-100]="stat.accent === 'warm'"
                [class.text-orange-600]="stat.accent === 'warm'" [class.bg-slate-100]="stat.accent !== 'warm'"
                [class.text-slate-700]="stat.accent !== 'warm'">
                {{ stat.change }}
              </span>
            </div>
          </div>
          }
        </div>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div class="stat-card md:col-span-2">
            <div class="mb-4">
              <h3 class="text-lg font-semibold text-slate-900">Enrollment Trend</h3>
              <p class="text-sm text-slate-500">Monthly enrollments vs completions</p>
            </div>
            <div echarts [options]="enrollmentTrendOptions" class="h-[320px] w-full z-0"></div>
          </div>
          <div class="stat-card">
            <div class="mb-4">
              <h3 class="text-lg font-semibold text-slate-900">Engagement Split</h3>
              <p class="text-sm text-slate-500">Learner activity distribution</p>
            </div>
            <div echarts [options]="engagementSplitOptions" class="h-[320px] w-full"></div>
          </div>
          <div class="stat-card md:col-span-3">
            <div class="mb-4">
              <h3 class="text-lg font-semibold text-slate-900">Category Performance</h3>
              <p class="text-sm text-slate-500">Enrollments and completion rate by category</p>
            </div>
            <div echarts [options]="categoryPerformanceOptions" class="h-[340px] w-full"></div>
          </div>
        </div>
      </div>
      }

    </div><!-- /tab content -->
  </div><!-- /max-w -->

  <!-- ═══ Change Password Modal ═══ -->
  @if (isPasswordModalOpen) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/50 p-4 z-50">
    <div class="w-full max-w-lg rounded-2xl bg-white shadow-2xl">
      <div class="border-b border-gray-200 px-6 py-4">
        <h3 class="text-2xl font-semibold text-gray-900">Change Password</h3>
      </div>

      <div class="px-6 py-6">
        <form [formGroup]="changePasswordForm" class="space-y-4">
          <div>
            <label class="label">
              <span class="label-text font-semibold">
                New Password <span class="text-red-500">*</span>
              </span>
            </label>

            <input formControlName="password" type="password" class="input input-bordered w-full" />

            @if (changePasswordForm.get('password')?.touched &&
            changePasswordForm.get('password')?.errors?.['required']) {
            <p class="text-red-500 text-sm mt-1">
              Password is required.
            </p>
            }

            @if (changePasswordForm.get('password')?.touched &&
            changePasswordForm.get('password')?.errors?.['passwordLength']) {
            <p class="text-red-500 text-sm mt-1">
              Password must be between 8 and 20 characters.
            </p>
            }

            @if (changePasswordForm.get('password')?.touched &&
            changePasswordForm.get('password')?.errors?.['passwordNoSpaces']) {
            <p class="text-red-500 text-sm mt-1">
              Password cannot contain spaces.
            </p>
            }

            @if (changePasswordForm.get('password')?.touched &&
            (changePasswordForm.get('password')?.errors?.['passwordUppercase'] ||
             changePasswordForm.get('password')?.errors?.['passwordLowercase'] ||
             changePasswordForm.get('password')?.errors?.['passwordDigit'] ||
             changePasswordForm.get('password')?.errors?.['passwordSpecialChar'])) {
            <p class="text-red-500 text-sm mt-1">
              Password must include uppercase, lowercase, digit, and special character.
            </p>
            }
          </div>

          <div>
            <label class="label">
              <span class="label-text font-semibold">
                Confirm Password <span class="text-red-500">*</span>
              </span>
            </label>

            <input formControlName="password_confirmation" type="password" class="input input-bordered w-full" />

            @if (changePasswordForm.get('password_confirmation')?.touched &&
            changePasswordForm.get('password_confirmation')?.errors?.['required']) {
            <p class="text-red-500 text-sm mt-1">
              Confirm Password is required.
            </p>
            }

            @if (changePasswordForm.get('password_confirmation')?.touched &&
            changePasswordForm.get('password_confirmation')?.errors?.['passwordLength']) {
            <p class="text-red-500 text-sm mt-1">
              Confirm Password must be between 8 and 20 characters.
            </p>
            }

            @if (changePasswordForm.get('password_confirmation')?.touched &&
            changePasswordForm.get('password_confirmation')?.errors?.['passwordNoSpaces']) {
            <p class="text-red-500 text-sm mt-1">
              Confirm Password cannot contain spaces.
            </p>
            }

            @if (changePasswordForm.get('password_confirmation')?.touched &&
            (changePasswordForm.get('password_confirmation')?.errors?.['passwordUppercase'] ||
             changePasswordForm.get('password_confirmation')?.errors?.['passwordLowercase'] ||
             changePasswordForm.get('password_confirmation')?.errors?.['passwordDigit'] ||
             changePasswordForm.get('password_confirmation')?.errors?.['passwordSpecialChar'])) {
            <p class="text-red-500 text-sm mt-1">
              Confirm Password must include uppercase, lowercase, digit, and special character.
            </p>
            }
          </div>

          @if (
          changePasswordForm.errors?.['mismatch'] &&
          !changePasswordForm.get('password')?.errors?.['passwordLength'] &&
          !changePasswordForm.get('password_confirmation')?.errors?.['passwordLength'] &&
          !changePasswordForm.get('password')?.errors?.['passwordNoSpaces'] &&
          !changePasswordForm.get('password_confirmation')?.errors?.['passwordNoSpaces']
          ) {
          <p class="text-red-500 text-sm mt-2">
            Passwords do not match.
          </p>
          }


        </form>
      </div>

      <div class="flex justify-end gap-3 border-t border-gray-200 px-6 py-4">
        <button type="button" (click)="isPasswordModalOpen = false" class="btn btn-outline px-6">Cancel</button>
        <button type="button" (click)="onSaveChangePassword()" class="btn btn-primary px-6">Save</button>
      </div>
    </div>
  </div>
  }

  <!-- ═══ Course Modal ═══ -->
  @if (isCourseModalOpen) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/50 p-4 z-50">
    <div class="w-full max-w-6xl rounded-2xl bg-white shadow-2xl">
      <div class="border-b border-gray-200 px-6 py-4">
        <h3 class="text-2xl font-semibold text-gray-900">Select Courses</h3>
      </div>
      <div class="max-h-[70vh] overflow-y-auto px-6 py-6">
        @if (isCoursesLoading) {
        <div class="py-16 text-center text-gray-500">Loading courses...</div>
        } @else if (availableCourses.length > 0) {
        <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          @for (course of availableCourses; track course.id) {
          <button type="button" (click)="toggleCourseSelection(course.id)"
            class="overflow-hidden rounded-xl border text-left transition-all"
            [class.border-blue-500]="isCourseSelected(course.id)" [class.bg-blue-50]="isCourseSelected(course.id)"
            [class.shadow-lg]="isCourseSelected(course.id)" [class.border-gray-200]="!isCourseSelected(course.id)">
            <div class="relative h-40">
              <img [src]="getCourseThumbnailUrl(course.thumbnail)" [alt]="course.name"
                class="h-full w-full object-cover" />
              @if (isCourseSelected(course.id)) {
              <span
                class="absolute right-3 top-3 rounded-full bg-blue-600 px-3 py-1 text-xs font-semibold text-white">Selected</span>
              }
            </div>
            <div class="p-4 flex items-start gap-3">
              <input type="checkbox" class="checkbox mt-0.5 w-4 h-4 rounded-none bg-gray-300 border-gray-400 checked:bg-gray-500 checked:border-gray-500"
                [checked]="isCourseSelected(course.id)"
                (click)="$event.stopPropagation()"
                (change)="toggleCourseSelection(course.id)" />

              <h4 class="text-base font-semibold text-gray-900">{{ course.name }}</h4>
            </div>
          </button>
          }
        </div>

        <!-- Bottom pagination -->
        <div class="m-4 flex justify-center items-end">
          <app-pagination [data]="coursesPaginationData" (pageChange)="onCoursesPageChange($event)"></app-pagination>
        </div>
        } @else {
        <div class="py-16 text-center text-gray-500">No courses found from API.</div>
        }
      </div>
      <div class="flex justify-end gap-3 border-t border-gray-200 px-6 py-4">
        <button type="button" (click)="closeCourseModal()" class="btn btn-outline px-6">Cancel</button>
        <button type="button" (click)="saveSelectedCourses()" class="btn btn-primary px-6">Save</button>
      </div>
    </div>
  </div>
  }

  <!-- ═══ Reusable error message template ═══ -->
  <ng-template #errMsg let-ctrl="ctrl" let-label="label">
    @if (ctrl && (ctrl.touched || ctrl.dirty || submitAttempted) && ctrl.errors) {
    <div class="text-red-500 text-xs mt-1 space-y-1">
      @if (ctrl.errors['required']) { <p>{{ label }} is required.</p> }
      @if (ctrl.errors['email']) { <p>Please enter a valid email address.</p> }
      @if (ctrl.errors['minlength']) { <p>{{ label }} must be at least {{ ctrl.errors['minlength'].requiredLength }} characters.</p> }
      @if (ctrl.errors['maxlength']) { <p>{{ label }} must not exceed {{ ctrl.errors['maxlength'].requiredLength }} characters.</p> }
      @if (ctrl.errors['pattern']) { <p>{{ label }} format is invalid.</p> }
      
      <!-- Name specific errors -->
      @if (ctrl.errors['nameLength']) { <p>{{ label }} must be between {{ ctrl.errors['nameLength'].min }} and {{ ctrl.errors['nameLength'].max }} characters.</p> }
      @if (ctrl.errors['namePattern']) { <p>Only alphabets and spaces are allowed.</p> }
      
      <!-- About College specific errors -->
      @if (ctrl.errors['aboutCollegeLength']) { <p>{{ label }} must be between {{ ctrl.errors['aboutCollegeLength'].min }} and {{ ctrl.errors['aboutCollegeLength'].max }} characters.</p> }
      @if (ctrl.errors['aboutCollegePattern']) { <p>Please enter valid college information.</p> }
      
      <!-- Address specific errors -->
      @if (ctrl.errors['addressLength']) { <p>{{ label }} must be between {{ ctrl.errors['addressLength'].min }} and {{ ctrl.errors['addressLength'].max }} characters.</p> }
      @if (ctrl.errors['addressPattern']) { <p>Please enter a valid address.</p> }
      
      <!-- Contact number specific errors -->
      @if (ctrl.errors['contactDigitsOnly']) { <p>Only digits are allowed.</p> }
      @if (ctrl.errors['contactLength']) { <p>Contact number must be exactly {{ ctrl.errors['contactLength'].expected }} digits.</p> }
      
      <!-- Email specific errors -->
      @if (ctrl.errors['emailNoSpaces']) { <p>Email cannot contain spaces.</p> }
      @if (ctrl.errors['emailMaxLength']) { <p>Email must not exceed {{ ctrl.errors['emailMaxLength'].max }} characters.</p> }
      @if (ctrl.errors['emailFormat']) { <p>Please enter a valid email address.</p> }
      
      <!-- Username specific errors -->
      @if (ctrl.errors['usernameLength']) { <p>{{ label }} must be between {{ ctrl.errors['usernameLength'].min }} and {{ ctrl.errors['usernameLength'].max }} characters.</p> }
      @if (ctrl.errors['usernamePattern']) { <p>Only alphabets, numbers, underscore (_), and period (.) are allowed.</p> }
      @if (ctrl.errors['usernameNoSpaces']) { <p>Spaces are not allowed.</p> }
      
      <!-- Password specific errors -->
      @if (ctrl.errors['passwordLength']) { <p>{{ label }} must be between {{ ctrl.errors['passwordLength'].min }} and {{ ctrl.errors['passwordLength'].max }} characters.</p> }
      @if (ctrl.errors['passwordNoSpaces']) { <p>Password cannot contain spaces.</p> }
      @if (ctrl.errors['passwordUppercase']) { <p>At least 1 uppercase letter required.</p> }
      @if (ctrl.errors['passwordLowercase']) { <p>At least 1 lowercase letter required.</p> }
      @if (ctrl.errors['passwordDigit']) { <p>At least 1 digit required.</p> }
      @if (ctrl.errors['passwordSpecialChar']) { <p>At least 1 special character (&#64; # $ % &amp; * !) required.</p> }
      
      <!-- Institute Name specific errors -->
      @if (ctrl.errors['instituteNameMaxLength']) { <p>{{ label }} must not exceed {{ ctrl.errors['instituteNameMaxLength'].max }} characters.</p> }
       @if (ctrl.errors['instituteNameMinLength']) { <p>{{ label }} must be at least {{ ctrl.errors['instituteNameMinLength'].min }} characters.</p> }
      <!-- Designation specific errors -->
      @if (ctrl.errors['designationLength']) { <p>{{ label }} must be between {{ ctrl.errors['designationLength'].min }} and {{ ctrl.errors['designationLength'].max }} characters.</p> }
      @if (ctrl.errors['designationPattern']) { <p>Only alphabets and spaces are allowed.</p> }
    </div>
    }
  </ng-template>

</section>

